  function verificarDispositivo() {

    const isMobile = window.innerWidth <= 990;

    document.querySelectorAll('[data-conteudo-formato]').forEach(item => {

      const formato = item.dataset.conteudoFormato;

      if(isMobile && formato === 'desktop'){
        item.hidden = true;
      } else if(!isMobile && formato === 'mobile'){
        item.hidden = true;
      } else {
        item.hidden = false;
      }

    });

  }

  verificarDispositivo();

  window.addEventListener('resize', verificarDispositivo);
